module.exports = __webpack_public_path__ + "img/Paula Keskula.88228221.jpg";